/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as HomeIndexImport } from './routes/Home/index'
import { Route as UsersInviteImport } from './routes/Users/Invite'
import { Route as TripsCreateImport } from './routes/Trips/Create'
import { Route as AuthResetPasswordImport } from './routes/Auth/ResetPassword'
import { Route as AuthLoginImport } from './routes/Auth/Login'
import { Route as AuthForgetPasswordImport } from './routes/Auth/ForgetPassword'
import { Route as TripsTripIdTrackImport } from './routes/Trips/$TripId/Track'

// Create/Update Routes

const HomeIndexRoute = HomeIndexImport.update({
  path: '/Home/',
  getParentRoute: () => rootRoute,
} as any)

const UsersInviteRoute = UsersInviteImport.update({
  path: '/Users/Invite',
  getParentRoute: () => rootRoute,
} as any)

const TripsCreateRoute = TripsCreateImport.update({
  path: '/Trips/Create',
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  path: '/Auth/ResetPassword',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  path: '/Auth/Login',
  getParentRoute: () => rootRoute,
} as any)

const AuthForgetPasswordRoute = AuthForgetPasswordImport.update({
  path: '/Auth/ForgetPassword',
  getParentRoute: () => rootRoute,
} as any)

const TripsTripIdTrackRoute = TripsTripIdTrackImport.update({
  path: '/Trips/$TripId/Track',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/Auth/ForgetPassword': {
      id: '/Auth/ForgetPassword'
      path: '/Auth/ForgetPassword'
      fullPath: '/Auth/ForgetPassword'
      preLoaderRoute: typeof AuthForgetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/Auth/Login': {
      id: '/Auth/Login'
      path: '/Auth/Login'
      fullPath: '/Auth/Login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/Auth/ResetPassword': {
      id: '/Auth/ResetPassword'
      path: '/Auth/ResetPassword'
      fullPath: '/Auth/ResetPassword'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/Trips/Create': {
      id: '/Trips/Create'
      path: '/Trips/Create'
      fullPath: '/Trips/Create'
      preLoaderRoute: typeof TripsCreateImport
      parentRoute: typeof rootRoute
    }
    '/Users/Invite': {
      id: '/Users/Invite'
      path: '/Users/Invite'
      fullPath: '/Users/Invite'
      preLoaderRoute: typeof UsersInviteImport
      parentRoute: typeof rootRoute
    }
    '/Home/': {
      id: '/Home/'
      path: '/Home'
      fullPath: '/Home'
      preLoaderRoute: typeof HomeIndexImport
      parentRoute: typeof rootRoute
    }
    '/Trips/$TripId/Track': {
      id: '/Trips/$TripId/Track'
      path: '/Trips/$TripId/Track'
      fullPath: '/Trips/$TripId/Track'
      preLoaderRoute: typeof TripsTripIdTrackImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  AuthForgetPasswordRoute,
  AuthLoginRoute,
  AuthResetPasswordRoute,
  TripsCreateRoute,
  UsersInviteRoute,
  HomeIndexRoute,
  TripsTripIdTrackRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/Auth/ForgetPassword",
        "/Auth/Login",
        "/Auth/ResetPassword",
        "/Trips/Create",
        "/Users/Invite",
        "/Home/",
        "/Trips/$TripId/Track"
      ]
    },
    "/Auth/ForgetPassword": {
      "filePath": "Auth/ForgetPassword.tsx"
    },
    "/Auth/Login": {
      "filePath": "Auth/Login.tsx"
    },
    "/Auth/ResetPassword": {
      "filePath": "Auth/ResetPassword.tsx"
    },
    "/Trips/Create": {
      "filePath": "Trips/Create.tsx"
    },
    "/Users/Invite": {
      "filePath": "Users/Invite.tsx"
    },
    "/Home/": {
      "filePath": "Home/index.tsx"
    },
    "/Trips/$TripId/Track": {
      "filePath": "Trips/$TripId/Track.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
